import React from 'react';
import Text from '@/components/Typography/Text';
import { Section, useLanding } from '@/components/Landing/LandingKit';
import { fluid } from '@/components/Landing/landingTokens';

/** The same quiet headings and section rhythm as the landing and about pages. */
export function PricingSection({ label, background, children }) {
  const { c, width } = useLanding();
  return (
    <Section label={label} background={background} style={{ borderTopWidth: 1, borderTopColor: c.rule }} contentStyle={{ paddingTop: fluid(width, 44, 72), paddingBottom: fluid(width, 44, 72) }}>
      {children}
    </Section>
  );
}

export function PricingTitle({ children }) {
  const { c, width } = useLanding();
  const size = fluid(width, 29, 36);
  return (
    <Text tag="h2" weight="semibold" style={{ color: c.ink, fontSize: size, lineHeight: Math.round(size * 1.15), letterSpacing: -size * 0.035 }}>
      {children}
    </Text>
  );
}
